import React, { ReactNode, RefObject } from 'react';
import { SnackbarKey } from 'notistack';

import { NOTIFICATION_TYPES } from '@components/Notification';
import { IExclamationMarkCircleIconProps } from '@icons/ExclamationMarkCircleIcon';
import { ICheckCircleIconProps } from '@icons/CheckCircleIcon';

export interface IEventNotification {
  ref?: RefObject<HTMLDivElement>;
  id: SnackbarKey;
  message: string | ReactNode;
  type: NOTIFICATION_TYPES;
  onLeave: () => void;
  onCancel: () => void;
}

export interface IEventNotificationView {
  message: string | ReactNode;
  color: string;
  colorIcon: string;
  background: string;
  icon:
    | React.FC<IExclamationMarkCircleIconProps>
    | React.FC<ICheckCircleIconProps>
    | null;
  onClickClose: () => void;
  onLeave: () => void;
}

export enum LeaveReasonEnum {
  UnfinishedLegacyWall = 'UNFINISHED_LEGACY_WALL',
  UnfinishedTryOn = 'UNFINISHED_TRY_ON',
  UnfinishedStyleStudio = 'UNFINISHED_STYLE_STUDIO',
}
